var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "../../../components/templates/flex";
import { getColor } from "../../../theme";
var StyledTab = styled(Flex).attrs(function (_a) {
    var active = _a.active;
    return ({
        gap: 1,
        background: active ? "mainBackground" : "elementBackground",
        padding: [2, 3],
        round: { side: "top" },
        border: { side: "all", color: "tabsBorder" },
        alignItems: "center",
        justifyContent: "start",
        position: "relative",
        zIndex: active ? 2 : 0,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  top: ", ";\n  border-bottom-color: ", ";\n  cursor: pointer;\n"], ["\n  top: ", ";\n  border-bottom-color: ", ";\n  cursor: pointer;\n"])), function (_a) {
    var active = _a.active;
    return !active && "2px";
}, function (_a) {
    var active = _a.active;
    return active && getColor("mainBackground");
});
export default StyledTab;
var templateObject_1;
